// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import UpdateShippingAddress from './UpdateShippingAddress';
import type { UpdateShippingAddressProps } from './UpdateShippingAddress';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.UpdateShippingAddressModal.title"
            defaultMessage="Edit Shipping Destination"
        />
    ),
};

type UpdateInstallDateModalProps = {|
    ...UpdateShippingAddressProps,
    isOpen?: boolean,
    onClose: Function,
|};

export function UpdateShippingAddressModal(props: UpdateInstallDateModalProps) {
    const { isOpen, onClose, ...updateShippingProps } = props;

    return (
        <ModalContainer isOpen={!!isOpen} modalPosition="center" onClose={onClose}>
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <UpdateShippingAddress {...updateShippingProps} />
            </ModalBody>
        </ModalContainer>
    );
}

export default UpdateShippingAddressModal;
